module.exports = __webpack_public_path__ + "media/newstyle/images/lp-banner-b-desktop-red-205677e1720b83005158491edb210d88.png";